module.exports = __webpack_public_path__ + "static/img/female-5.68015042.png";